import { Component, DoCheck, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { Router } from '@angular/router';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { getNetworkLogo } from 'src/app/core/utils/network-logo.util';
import { buildFooterTheme, logoNeedsPanel, sampleLogoLuminance } from './ic-footer-theme';

/**
 * New-design network footer (ENABLE_NEW_FOOTER). Every section is driven by the network's own
 * data - logo, schools, app-store links, colours - so it lays out without gaps for any network.
 * Link navigation stays in the parent ic-footer via (navigate).
 */
@Component({
  selector: 'app-ic-footer-v2',
  templateUrl: './ic-footer-v2.component.html',
  styleUrls: ['./ic-footer-v2.component.scss'],
})
export class IcFooterV2Component implements OnChanges, DoCheck {
  @Input() settingsData: any = {};
  @Input() performerDetails: any;
  @Input() deviceType: any;
  @Input() channelName: string;
  /** Keeps room under the footer only while the fixed music player is showing. */
  @Input() reserveBottomSpace = false;
  @Output() navigate = new EventEmitter<string>();

  copyRightYear = new Date().getFullYear();
  footerTheme: { [key: string]: string } = {};
  logoUrl = '';
  showLogoPanel = false;
  private sampledKey: string;

  constructor(private commanSubscribeService: CommanSubscribeService, private router: Router) {}

  ngOnChanges() {
    this.footerTheme = buildFooterTheme(this.settingsData, this.commanSubscribeService.defaultSettingsData);
  }

  // Performer info can land after the footer renders, so the logo is re-resolved each check;
  // the async contrast sampling only reruns when the logo or the background actually changes.
  ngDoCheck() {
    this.logoUrl = getNetworkLogo(this.commanSubscribeService.perfomerInfoData, this.settingsData);
    const bg = this.footerTheme['--ftr-bg'];
    const key = this.logoUrl + '|' + bg;
    if (!this.logoUrl || key === this.sampledKey) {
      return;
    }
    this.sampledKey = key;
    this.showLogoPanel = false;
    const logo = this.logoUrl;
    sampleLogoLuminance(logo).then(lum => {
      if (logo === this.logoUrl) {
        this.showLogoPanel = logoNeedsPanel(lum, bg);
      }
    });
  }

  get networkName(): string {
    return this.settingsData?.channelInfo?.channel_display_name || this.performerDetails?.organization_name || '';
  }

  // Same rule as the AI agent's groups row: is_group_supported plus a non-empty groups list.
  get groups(): any[] {
    const data = this.commanSubscribeService.perfomerInfoData?.data?.Data?.[0];
    return data?.is_group_supported && Array.isArray(data.groups) ? data.groups : [];
  }

  get groupsLabel(): string {
    return (this.commanSubscribeService.perfomerInfoData?.data?.Data?.[0]?.network_type_label || 'Groups').toUpperCase();
  }

  // Same as the header logo on a network page: network home, then reload the network-level theme.
  goToNetworkHome() {
    if (this.channelName && !this.router.url.includes('/preview')) {
      this.router.navigateByUrl('/' + this.channelName);
      this.commanSubscribeService.getWebPageSettings(0);
    }
  }

  goToGroup(group: any) {
    if (group?.group_slug && !this.router.url.includes('/preview')) {
      this.router.navigateByUrl('/' + this.channelName + '/' + group.group_slug);
    }
  }
}
